import { showLessTextLabel, showMoreTextLabel } from './PeekEventContent.locstring.json';
import { ActionButton, IButtonStyles } from '@fluentui/react/lib/Button';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import loc from 'owa-localize';
import { getPalette } from 'owa-theme';
import * as React from 'react';
import { observer as observerLite } from 'mobx-react-lite';

export interface ShowMoreButtonProps {
    onClick: () => void;
    shouldShowMore: boolean;
    colorScheme: ColorScheme;
}

export default observerLite(function ShowMoreButton(props: ShowMoreButtonProps) {
    const { onClick, shouldShowMore, colorScheme } = props;

    const buttonStyle = getShowMoreButtonStyles(colorScheme);
    const text = shouldShowMore ? loc(showMoreTextLabel) : loc(showLessTextLabel);
    return <ActionButton styles={buttonStyle} text={text} onClick={onClick} />;
});

function getShowMoreButtonStyles(colorScheme: ColorScheme): IButtonStyles {
    const buttonColor =
        colorScheme?.accessibleText?.msColorWhiteBackground || getPalette().themePrimary;
    const buttonHoverColor = colorScheme ? colorScheme.calDarker : getPalette().themeDarker;

    return {
        root: {
            color: buttonColor,
            border: 0,
            padding: 0,
            margin: 0,
        },
        rootHovered: {
            color: buttonHoverColor,
        },
        rootPressed: {
            color: buttonHoverColor,
        },
        label: {
            margin: 0,
        },
    };
}
